import React from 'react';
import { Link } from 'react-router-dom';

// Interscope Ads brand mark — cyan + green overlapping squares with wordmark.
export default function BrandMark({ to = '/', className = '' }) {
  return (
    <Link to={to} className={`flex items-center gap-2.5 group shrink-0 ${className}`}>
      <span className="relative w-9 h-9 inline-block">
        <span className="absolute top-[3px] left-[7px] w-6 h-6 rounded-[7px] border-[3px] border-[#21A8CB] group-hover:rotate-6 transition-transform" />
        <span className="absolute bottom-0 left-0 w-[22px] h-[22px] rounded-[6px] bg-[#8CC53F] group-hover:-rotate-6 transition-transform" />
        <span className="absolute top-[3px] left-[3px] w-[13px] h-[13px] rounded-[4px] bg-[#21A8CB]" />
      </span>
      <span className="font-display font-bold tracking-tight leading-none text-xl">
        <span className="text-[#1B8CAD]">INTER</span>
        <span className="text-[#2596B8] font-normal">SCOPE</span>
        <span className="block text-[9px] tracking-[0.5em] text-[#5E9430] mt-1 font-semibold">ADS</span>
      </span>
    </Link>
  );
}
